import { render, staticRenderFns } from "./LoadsCharts.vue?vue&type=template&id=b2df6d14&"
import script from "./LoadsCharts.vue?vue&type=script&lang=js&"
export * from "./LoadsCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports